module.exports = __webpack_public_path__ + "media/images/close-menu-64ba8dc74d3a937c89a0514c40a71762.svg";